<template>
  <div class="animaedu">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <a href="https://animaedu.com/" target="_blank">
            <h4 class="client">AnimaEdu</h4>
          </a>
          <h1 class="title">
            {{ $t("animaedu.title") }}
          </h1>
          <p class="date">
            {{ $t("animaedu.duration.title") }}
            {{ $t("animaedu.duration.date") }}
          </p>
          <p class="role">
            {{ $t("animaedu.position.title") }}
            {{ $t("animaedu.position.role") }}
          </p>
          <p class="description">
            {{ $t("animaedu.description") }}
          </p>
          <ul class="menu-list">
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("animaedu.bullet1") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("animaedu.bullet2") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("animaedu.bullet3") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("animaedu.bullet4") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("animaedu.bullet5") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("animaedu.bullet6") }}
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <img src="@/assets/animaedu.png" alt="" class="demo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnimaEdu",
  components: {},
};
</script>
<style lang="scss" scoped>
div.animaedu {
  background-color: #8e4796;
  display: flex;
  justify-content: center;
  padding: 4rem 0;

  div.columns {
    height: 100%;
  }

  @media (min-width: 600px) {
    height: 100vh;
    padding: 0;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem;
    font-family: "Raleway";

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      color: rgba(#fff, 0.5);
      font-weight: bold;
      //margin-bottom: 0.5rem;
    }

    h1.title {
      color: rgba(#fff, 0.9);
      font-family: "Raleway";
      text-align: start;
    }

    p.description {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: rgba(#fff, 0.8);
      margin-top: 1.5rem;
    }

    p.date,
    p.role {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #ccc;
      font-size: 1.2rem;
    }

    ul {
      font-family: "Raleway";
      list-style: inside;
      color: rgba(#fff, 0.7);
      li {
        text-align: left;
        margin: 0.5rem 0;
        // font-weight: 500;
      }
    }
  }

  div.multimedia-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 85%;
      box-shadow: 3px 3px 38px 7px #000;
    }
  }
}
</style>
